/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { MaterielParcDto } from '../models/materiel-parc-dto';


/**
 * Fonctions de gestion du matériel des recyparcs
 */
@Injectable({
  providedIn: 'root',
})
export class MaterielRecyparcsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation materielParcGetList
   */
  static readonly MaterielParcGetListPath = '/api/materiel-recyparcs/list/{parcId}';

  /**
   * Renvoie la liste des matériels du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `materielParcGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  materielParcGetList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<MaterielParcDto>>> {

    const rb = new RequestBuilder(this.rootUrl, MaterielRecyparcsService.MaterielParcGetListPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MaterielParcDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des matériels du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `materielParcGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  materielParcGetList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<Array<MaterielParcDto>> {

    return this.materielParcGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MaterielParcDto>>) => r.body as Array<MaterielParcDto>)
    );
  }

  /**
   * Path part for operation materielParcLoadList
   */
  static readonly MaterielParcLoadListPath = '/api/materiel-recyparcs/load-list/{parcId}';

  /**
   * Renvoie la liste des matériels du recyparc spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `materielParcLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  materielParcLoadList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, MaterielRecyparcsService.MaterielParcLoadListPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des matériels du recyparc spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `materielParcLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  materielParcLoadList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.materielParcLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation materielParcGet
   */
  static readonly MaterielParcGetPath = '/api/materiel-recyparcs/{id}';

  /**
   * Renvoie le matériel spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `materielParcGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  materielParcGet$Response(params: {

    /**
     * Identifiant du matériel
     */
    id: number;
  }): Observable<StrictHttpResponse<MaterielParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, MaterielRecyparcsService.MaterielParcGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MaterielParcDto>;
      })
    );
  }

  /**
   * Renvoie le matériel spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `materielParcGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  materielParcGet(params: {

    /**
     * Identifiant du matériel
     */
    id: number;
  }): Observable<MaterielParcDto> {

    return this.materielParcGet$Response(params).pipe(
      map((r: StrictHttpResponse<MaterielParcDto>) => r.body as MaterielParcDto)
    );
  }

  /**
   * Path part for operation materielParcPut
   */
  static readonly MaterielParcPutPath = '/api/materiel-recyparcs/{id}';

  /**
   * Met à jour le matériel spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `materielParcPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  materielParcPut$Response(params: {

    /**
     * Identifiant du matériel à mettre à jour
     */
    id: number;

    /**
     * Matériel
     */
    body: MaterielParcDto
  }): Observable<StrictHttpResponse<MaterielParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, MaterielRecyparcsService.MaterielParcPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MaterielParcDto>;
      })
    );
  }

  /**
   * Met à jour le matériel spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `materielParcPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  materielParcPut(params: {

    /**
     * Identifiant du matériel à mettre à jour
     */
    id: number;

    /**
     * Matériel
     */
    body: MaterielParcDto
  }): Observable<MaterielParcDto> {

    return this.materielParcPut$Response(params).pipe(
      map((r: StrictHttpResponse<MaterielParcDto>) => r.body as MaterielParcDto)
    );
  }

  /**
   * Path part for operation materielParcDelete
   */
  static readonly MaterielParcDeletePath = '/api/materiel-recyparcs/{id}';

  /**
   * Supprime le matériel spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `materielParcDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  materielParcDelete$Response(params: {

    /**
     * Identifiant du matériel à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, MaterielRecyparcsService.MaterielParcDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le matériel spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `materielParcDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  materielParcDelete(params: {

    /**
     * Identifiant du matériel à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.materielParcDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation materielParcPost
   */
  static readonly MaterielParcPostPath = '/api/materiel-recyparcs/{parcId}';

  /**
   * Crée le matériel spécifié pour un recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `materielParcPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  materielParcPost$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Matériel
     */
    body: MaterielParcDto
  }): Observable<StrictHttpResponse<MaterielParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, MaterielRecyparcsService.MaterielParcPostPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MaterielParcDto>;
      })
    );
  }

  /**
   * Crée le matériel spécifié pour un recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `materielParcPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  materielParcPost(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Matériel
     */
    body: MaterielParcDto
  }): Observable<MaterielParcDto> {

    return this.materielParcPost$Response(params).pipe(
      map((r: StrictHttpResponse<MaterielParcDto>) => r.body as MaterielParcDto)
    );
  }

}
